import { Injectable } from '@angular/core';
import { switchMap, map, flatMap } from 'rxjs';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import * as invoiceUploadActions from '@invoice-upload/actions/invoice-upload.actions';
import { InvoiceUploadHttpService } from '@invoice-upload/services/invoice-upload-http.service';

@Injectable()
export class InvoiceUploadEffects {

  constructor(
    private readonly actions$: Actions,
    private readonly invoiceUploadHttpService: InvoiceUploadHttpService
  ) { }

  loadEffect$ = createEffect(() => this.actions$.pipe(
    ofType(invoiceUploadActions.load),
    flatMap((action) => {
      return this.invoiceUploadHttpService.getInvoices(action.widgetConfigurationId).pipe(
        map(invoices => invoiceUploadActions.loadComplete({ widgetConfigurationId: action.widgetConfigurationId, invoices }))
      );
    })
  ));
}

